<ul ngbNav #nav="ngbNav" [(activeId)]="activeTab" class="nav-tabs nav-pills sub-nav">
  <li [ngbNavItem]="'week'" domId="tab_week">
    <a ngbNavLink (click)="changeChart('week')" i18n="@@ThisWeekNavLink" *ngIf="permissions?.chargingStatisticsWeek">Woche</a>
  </li>
  <li [ngbNavItem]="'month'" domId="tab_month">
    <a ngbNavLink (click)="changeChart('month')" *ngIf="permissions?.chargingStatisticsMonth" i18n="@@ThisMonthNavLink">Monat</a>
  </li>
  <li [ngbNavItem]="'year'" domId="tab_year">
    <a ngbNavLink (click)="changeChart('year')" *ngIf="permissions?.chargingStatisticsYear" i18n="@@ThisYearNavLink">Jahr</a>
  </li>
  <li [ngbNavItem]="'own'" domId="tab_own">
    <a ngbNavLink (click)="changeChart('own')" i18n="@@ThisOwnNavLink">Angepasst</a>
 </li>

  <li domId="tab_own" style="margin-left: auto;">
    <a (click)="setShowChart2(false)" i18n="@@ShowPower"
      [style]="showChart2 ? '' : 'background: rgba(239 124 0 / .1); color: rgb(139 24 0)'"
      class="d-inline-block px-3 py-2 text-decoration-none rounded-top">Lademenge</a>
    <a (click)="setShowChart2(true)" i18n="@@ShowEmission"
      [style]="!showChart2 ? '' : 'background: rgba(0 239 124 / .1); color: rgb(0 139 24)'"
      class="d-inline-block px-3 py-2 text-decoration-none rounded-top">CO₂-Einsparung</a>
 </li>
</ul>

<div class="tab-content h-100" id="nav-tabContent">

  <form class="filterbox mt-3 d-flex flex-column flex-md-row flex-lg-row flex-wrap w-100" [formGroup]="formService.form" *ngIf="formService.formCreated">

    <div class="flex-fill pe-2 mb-2" style="max-width:400px" *ngIf="formService.formCreated && activeTab != 'year'">
      <div class="form-group">

        <div ngbDropdown style="width:100%" placement="bottom-rigth" #myDrop="ngbDropdown">

          <div class="input-group" style="width:100%">
            <input class="form-control" id="time_span" formControlName="range" placeholder="Bereich auswählen..." (change)="changeFromToDate($event)">
            <div class="input-group-append">
              <button ngbDropdownToggle id="time_span_dropdown" class="btn btn-primary calendar rounded-0 rounded-end" type="button"></button>
            </div>
          </div>

          <div ngbDropdownMenu style="padding:0" class="date-picker">
            <ngb-datepicker #dp (dateSelect)="onDateSelection($event,myDrop)" [displayMonths]="2" [dayTemplate]="t" [footerTemplate]="activeTab == 'own' && datepickerFooter" outsideDays="hidden">
            </ngb-datepicker>
          </div>
        </div>

        <ng-template #t let-date let-focused="focused">
          <span class="custom-day"
                [class.focused]="focused"
                [class.range]="isRange(date)"
                [class.faded]="isHovered(date) || isInside(date)"
                (mouseenter)="hoveredDate = date"
                (mouseleave)="hoveredDate = null">
            {{ date.day }}
          </span>
        </ng-template>

        <ng-template #datepickerFooter>
          <hr class="my-0">
          <span class="ms-1" i18n="@@QuickSelect">Schnellwahl</span>
          <span class="text-secondary ms-1" i18n="@@Previous">Vorherige</span>
          <button class="btn btn-sm p-0 ms-1" (click)="footerPreviousClicked(1, myDrop)" id="1_day" i18n="@@1DayButton">1 Tag |</button>
          <button class="btn btn-sm p-0" (click)="footerPreviousClicked(3, myDrop)" id="3_days" i18n="@@3DayButton">3 Tage |</button>
          <button class="btn btn-sm p-0" (click)="footerPreviousClicked(5, myDrop)" id="5_days" i18n="@@5DayButton">5 Tage |</button>
          <button class="btn btn-sm p-0" (click)="footerPreviousClicked(7, myDrop)" id="7_days" i18n="@@7DayButton">7 Tage |</button>
          <button class="btn btn-sm p-0" (click)="footerPreviousClicked('week', myDrop)" id="week" i18n="@@WeekButton">Woche |</button>
          <button class="btn btn-sm p-0" (click)="footerPreviousClicked('month', myDrop)" id="month" i18n="@@MonthButton">Monat</button>
        </ng-template>
      </div>
    </div>

    <div class="flex-fill pe-2 mb-2" *ngIf="formService.formCreated && activeTab == 'year'">
      <div class="form-group">
        <input type="number" id="year_input" class="form-control" min="2000" max="9998" i18n-placeholder="@@Year" placeholder="Jahr" formControlName="selectedYear" (change)="changeYear($event)" />
      </div>
    </div>

    <div class="flex-fill pe-2 mb-2" *ngIf="formService.formCreated && !isUser">
      <div class="form-group">
        <ng-select *ngIf="permissions?.chargingStatisticsFilter" #userSelect id="select_user"
                   [items]="filteredUsers"
                   bindLabel="fullName"
                   bindValue="id"
                   i18n-placeholder="@@User"
                   placeholder="Benutzer"
                   formControlName="selectedUserId"
                   (change)="changeLocalFilter()"
                   [ngClass]="form-control">
        </ng-select>
      </div>
    </div>

    <div class="flex-fill pe-2 mb-2" *ngIf="formService.formCreated && !isUser">
      <div class="form-group">
        <ng-select *ngIf="permissions?.chargingStatisticsFilter" #chargingStationSelect id="select_chargingstation"
                   [items]="filteredChargingStations"
                   bindLabel="name"
                   bindValue="id"
                   i18n-placeholder="@@Chargingstation"
                   placeholder="Ladestation"
                   formControlName="selectedStationId"
                   (change)="changeLocalFilter()">
        </ng-select>
      </div>
    </div>

    <div class="flex-fill pe-2 mb-2" *ngIf="formService.formCreated && !isUser">
      <div class="form-group">
        <ng-select *ngIf="permissions?.chargingStatisticsFilter" #groupSelect id="select_group"
                   [items]="filteredGroups"
                   bindLabel="name"
                   bindValue="id"
                   i18n-placeholder="@@ChargingGroup"
                   placeholder="Gruppe"
                   formControlName="selectedGroupId"
                   (change)="changeLocalFilter()">
        </ng-select>
      </div>
    </div>

    <div class="flex-fill text-md-end pe-2 mb-2" *ngIf="permissions?.createDeliveryNotes && formService.formCreated && !isUser">
      <button class="btn btn-yellow me-2" (click)="openCreateDeliveryNoteDialog()" id="creat_deliverynote" i18n="@@CreateDeliveryNoteButton">
        <app-svg source="icons/feather/file-text" height="18"></app-svg>
        <span>&nbsp;Lieferschein erstellen</span>
      </button>
      <a class="btn btn-yellow" id="creat_deliverycsv" (click)="openCreateDeliveryCSVDialog()" *ngIf="permissions?.createDeliveryNotes">
        <app-svg source="icons/feather/save" height="18"></app-svg>
        <span class="d-none d-md-inline ps-2">Als CSV herunterladen</span>
      </a>
    </div>

  </form>

  <form>
    <div class="row">
      <div class="col-1 mt-2" *ngIf="permissions?.chargingStatisticsCheckBox">
        <input type="checkbox" value="Max" (change)="showMax($event)" id="checkbox_max" i18n="@@MaxCheckbox"> Max <br />
        <input type="checkbox" value="Min" (change)="showMin($event)" id="checkbox_min" I18n="@@MinCheckbox"> Min <br />
        <input type="checkbox" value="Average" (change)="showAve($event)" i18n="@@AverageCheckbox" id="checkbox_avg"> Ø Lademenge in kWh
      </div>
    </div>
  </form>

  <div class="card-body h-100" id="collapseExample">
    <div *ngIf="this.loading" class="loading-spinner-container" style="margin-top: 25vh; margin-bottom: -25vh;">
      <div class="spinner-border text-primary loading-spinner-md" role="status">
        <span class="visually-hidden-focusable" i18n="@@GeneratingStatisticsHint">Statistik wird generiert...</span>
      </div>
    </div>
    <canvas id="powerChart" class="min-height w-100"
      [class]="showChart2 ? 'd-none' : 'd-block'"
      [ngStyle]="{'visibility':!loading ? 'visible' : 'hidden'}"></canvas>
    <canvas id="emissionChart" class="min-height w-100"
      [class]="showChart2 ? 'd-block' : 'd-none'"
      [ngStyle]="{'visibility':!loading ? 'visible' : 'hidden'}"></canvas>
  </div>

  <!-- <div class="tab-pane fade active show h-100" id="nav" role="tabpanel" aria-labelledby="nav-tab">
    <div *ngIf="this.loading" class="loading-spinner-container">
      <div class="spinner-border text-primary loading-spinner-md" role="status">
        <span class="visually-hidden-focusable" i18n="@@GeneratingStatisticsHint">Statistik wird generiert...</span>
      </div>
    </div>
    <canvas id="powerChart" class="min-height w-100" style="display: block; box-sizing: border-box;" [ngStyle]="!loading ? 'visibility: visible' : 'visibility: hidden'"></canvas>
  </div> -->
</div>
